module.exports = __webpack_public_path__ + "img/activities-14.4d31bf71.jpg";